export const SET_SUBMODULES = 'SET_SUBMODULES';
export const SET_SUBMODULE = 'SET_SUBMODULE';
export const ADD_SUBMODULE = 'ADD_SUBMODULE';
export const UPDATE_SUBMODULE = 'UPDATE_SUBMODULE';
export const REMOVE_SUBMODULE = 'REMOVE_SUBMODULE';
export const CLEAR_SUBMODULE = 'CLEAR_SUBMODULE';
export const CLEAR_SUBMODULES = 'CLEAR_SUBMODULES';
